import axios from 'axios';

export function getWsToken() {
    return axios.get(
        `https://${
            process.env.REACT_APP_WEBSOCKET_DOMAIN ?? location.hostname
        }/api/v2/login/observer`
    );
}
